import { fetchJBPSettings } from 'legacy/lut/services/partner360/jbpSettings/fetchJBPSettings'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { RequestStatus } from '../../../../configs/service'
import { REQUEST_JBP_SETTINGS } from '../constants'
import { selectJBPSettings } from '../selectors/selectJBPSettings'
import { selectJBPSettingsStatus } from '../selectors/selectJBPSettingsStatus'

export const requestFetchJBPSettings = createAsyncThunk(REQUEST_JBP_SETTINGS, fetchJBPSettings, {
  condition(args, { getState }) {
    const state = getState()
    const jbpSettings = selectJBPSettings(state)
    const status = selectJBPSettingsStatus(state)

    if (status === RequestStatus.PENDING || jbpSettings.entryId) {
      return false
    }

    return
  },
})
